"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SigilOfBloodAbilityHandler = exports.SigilOfBloodActorAbilityFactory = exports.SigilOfBloodAbilityArgs = void 0;
const __1 = require("../..");
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const Passive_SigilOfBlood_1 = require("../../core/effects/core/Passive_SigilOfBlood");
const EffectType_1 = require("../../core/effects/EffectType");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
class SigilOfBloodAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.SigilOfBlood;
        this.__typeName = "SigilOfBlood";
    }
}
exports.SigilOfBloodAbilityArgs = SigilOfBloodAbilityArgs;
let SigilOfBloodActorAbilityFactory = class SigilOfBloodActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("SigilOfBlood", "OneEnemies", 4);
    }
};
SigilOfBloodActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("SigilOfBlood")
], SigilOfBloodActorAbilityFactory);
exports.SigilOfBloodActorAbilityFactory = SigilOfBloodActorAbilityFactory;
let SigilOfBloodAbilityHandler = class SigilOfBloodAbilityHandler {
    init(sequence, container, actorId) {
        container.applyBuff({
            sequence,
            creatorId: actorId,
            targetId: actorId,
            effect: new Passive_SigilOfBlood_1.Passive_SigilOfBloodEffectArgs(5),
            duration: Duration_1.Duration.Permanent,
        });
    }
    activate(sequence, container, ability) {
        sequence = sequence.pushSequence("parallel");
        const effects = container.getEffectsOfType(ability.invokerId, EffectType_1.EffectType.Passive_SigilOfBlood);
        for (const effect of effects) {
            container.cancelEffect(sequence, effect);
        }
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Power("Death", 100)
            ],
            onHit: (sequence) => {
                sequence.push(new __1.InstantVfxStepArgs(new __1.ActorVfxLocationSelector(selectedEnemy, "feet"), "DarkLightning"));
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    effect: new __1.StunEffectArgs(),
                    duration: Duration_1.Duration.Turns(1),
                });
            }
        });
        container.registerEventHandler(ability.invokerId, EventType_1.EventType.Killed, Schedule_1.Schedule.Once(), new __1.CancelEventHandlersEventHandlerArgs([
            container.registerEventHandler(ability.invokerId, EventType_1.EventType.TurnStarted, Schedule_1.Schedule.Combined(1, 1), new __1.ApplyEffectEventHandlerArgs(ability.invokerId, Target_1.Target.Self, Duration_1.Duration.Permanent, new Passive_SigilOfBlood_1.Passive_SigilOfBloodEffectArgs(5))),
        ]));
    }
};
SigilOfBloodAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.SigilOfBlood)
], SigilOfBloodAbilityHandler);
exports.SigilOfBloodAbilityHandler = SigilOfBloodAbilityHandler;
